/**
 * Zihin Kılavuzu - Akıllı Mikro Öğretim Hint Config
 * Hipnotik, bilinçaltı dostu tooltip konfigürasyonları
 */

export const HINT_CONFIG = {
  // ==========================================
  // ONBOARDING HINTS (ilk kullanım)
  // ==========================================
  onboarding: [
    {
      id: 'onb_dashboard',
      page: '/panel',
      targetSelector: '[data-hint="dashboard"]',
      trigger: { type: 'onFirstVisit' },
      level: { min: 'Farkındalık', max: 'Uyanış' },
      copy: {
        title: 'Hoş Geldin...',
        body: 'Burası yolculuğunun başladığı alan. Derin bir nefes al... ve keşfetmeye başla.',
        cta: 'Anladım'
      },
      behavior: { showOnce: true, autoDismissMs: 0, blockInteraction: false },
      position: 'bottom',
      order: 1
    },
    {
      id: 'onb_fisilti',
      page: '/panel',
      targetSelector: '[data-hint="fisilti-widget"]',
      trigger: { type: 'onFirstVisit' },
      level: { min: 'Farkındalık', max: 'Dönüşüm' },
      copy: {
        title: 'Fısıltı Alanı',
        body: 'Seni çağıran sesi seç... Bugünkü ritüelini tek dokunuşla başlat.',
        cta: 'Keşfet'
      },
      behavior: { showOnce: true, autoDismissMs: 0, blockInteraction: false },
      position: 'right',
      order: 2
    },
    {
      id: 'onb_telkin_play',
      page: '/panel/telkinler',
      targetSelector: '[data-hint="play-button"]',
      trigger: { type: 'onFirstVisit' },
      level: { min: 'Farkındalık', max: 'Dönüşüm' },
      copy: {
        title: 'Hazırsan...',
        body: 'Tek dokunuş yeter. Gözlerini kapat, nefesini derin al... ve zihnini aç.',
        cta: 'Başlat'
      },
      behavior: { showOnce: true, autoDismissMs: 0, blockInteraction: false },
      position: 'bottom',
      order: 3
    },
    {
      id: 'onb_favorites',
      page: '/panel/telkinler',
      targetSelector: '[data-hint="favorite-button"]',
      trigger: { type: 'onFirstVisit' },
      level: { min: 'Farkındalık', max: 'Uyanış' },
      copy: {
        title: 'Kalbine Bırak',
        body: 'Kalbine bıraktıkların burada bekliyor olacak. Sevdiklerini işaretle.',
        cta: 'Tamam'
      },
      behavior: { showOnce: true, autoDismissMs: 0, blockInteraction: false },
      position: 'left',
      order: 4
    },
    {
      id: 'onb_challenge',
      page: '/panel/zihin-yolculugum',
      targetSelector: '[data-hint="challenge"]',
      trigger: { type: 'onFirstVisit' },
      level: { min: 'Farkındalık', max: 'Dönüşüm' },
      copy: {
        title: 'Küçük Ritüeller',
        body: 'Küçük ritüeller büyük dönüşümler getirir. Kendi hızında ilerle.',
        cta: 'Gör'
      },
      behavior: { showOnce: true, autoDismissMs: 0, blockInteraction: false },
      position: 'bottom',
      order: 5
    },
    {
      id: 'onb_points',
      page: '/panel/zihin-puanlarim',
      targetSelector: '[data-hint="points"]',
      trigger: { type: 'onFirstVisit' },
      level: { min: 'Farkındalık', max: 'Uyanış' },
      copy: {
        title: 'Bu Bir İlerleyiş',
        body: 'Bu yarış değil, bir ilerleyiş. Her adımın karşılığı burada.',
        cta: 'Anladım'
      },
      behavior: { showOnce: true, autoDismissMs: 0, blockInteraction: false },
      position: 'bottom',
      order: 6
    },
    {
      id: 'onb_premium',
      page: '/panel',
      targetSelector: '[data-hint="premium"]',
      trigger: { type: 'onFirstVisit' },
      level: { min: 'Farkındalık', max: 'Dönüşüm' },
      copy: {
        title: 'Derinleşmek İstersen...',
        body: 'VIP alanı seni bekliyor. Daha derin telkinler, özel içerikler.',
        cta: 'Keşfet'
      },
      behavior: { showOnce: true, autoDismissMs: 0, blockInteraction: false },
      position: 'left',
      order: 7
    },
    {
      id: 'onb_search',
      page: '/panel/telkinler',
      targetSelector: '[data-hint="search"]',
      trigger: { type: 'onFirstVisit' },
      level: { min: 'Farkındalık', max: 'Uyanış' },
      copy: {
        title: 'Zihnin Ne Arıyor?',
        body: 'Bugün zihnin ne istiyor? Aradığını buradan bulabilirsin.',
        cta: 'Tamam'
      },
      behavior: { showOnce: true, autoDismissMs: 0, blockInteraction: false },
      position: 'bottom',
      order: 8
    }
  ],
  
  // ==========================================
  // CONTEXTUAL HINTS (kullanım anı)
  // ==========================================
  contextual: [
    {
      id: 'ctx_dashboard_center',
      page: '/panel',
      targetSelector: '.dashboard-main',
      trigger: { type: 'onElementVisible' },
      level: { min: 'Uyanış', max: 'Ustalık' },
      copy: {
        title: 'Merkez Alanın',
        body: 'Buradan tüm yolculuğunu takip edebilirsin.'
      },
      behavior: { showOnce: true, autoDismissMs: 5000, blockInteraction: false },
      position: 'bottom'
    },
    {
      id: 'ctx_telkin_card',
      page: '/panel/telkinler',
      targetSelector: '[data-hint="session-card"]',
      trigger: { type: 'onElementVisible' },
      level: { min: 'Uyanış', max: 'Dönüşüm' },
      copy: {
        title: 'İçgüdün Doğru Sesi Bilir',
        body: 'Sana en uygun telkini içgüdün zaten biliyor. Dinle.'
      },
      behavior: { showOnce: true, autoDismissMs: 4000, blockInteraction: false },
      position: 'top'
    },
    {
      id: 'ctx_pause',
      page: '*',
      targetSelector: '[data-hint="pause-button"]',
      trigger: { type: 'onEvent', event: 'TELKIN_PAUSE' },
      level: { min: 'Farkındalık', max: 'Mentor' },
      copy: {
        title: 'Durmak da İlerlemektir',
        body: 'Mola vermek zihnin dinlenmesini sağlar. Hazır olduğunda devam et.'
      },
      behavior: { showOnce: false, autoDismissMs: 3000, blockInteraction: false },
      position: 'top'
    },
    {
      id: 'ctx_completion',
      page: '*',
      targetSelector: '[data-hint="completion"]',
      trigger: { type: 'onEvent', event: 'TELKIN_COMPLETED' },
      level: { min: 'Farkındalık', max: 'Mentor' },
      copy: {
        title: 'İşte Bu!',
        body: 'Bir dönüşüm izi bıraktın. Her tamamlama seni güçlendirir.'
      },
      behavior: { showOnce: false, autoDismissMs: 4000, blockInteraction: false },
      position: 'center'
    },
    {
      id: 'ctx_streak_maintain',
      page: '/panel',
      targetSelector: '[data-hint="streak"]',
      trigger: { type: 'onEvent', event: 'STREAK_AT_RISK' },
      level: { min: 'Farkındalık', max: 'Ustalık' },
      copy: {
        title: 'Serini Koru',
        body: 'Bugün bir telkin dinleyerek serini koruyabilirsin.'
      },
      behavior: { showOnce: false, autoDismissMs: 5000, blockInteraction: false },
      position: 'bottom'
    },
    {
      id: 'ctx_settings',
      page: '/panel/profil',
      targetSelector: '[data-hint="settings"]',
      trigger: { type: 'onElementVisible' },
      level: { min: 'Uyanış', max: 'Dönüşüm' },
      copy: {
        title: 'Sistem Sana Uyum Sağlasın',
        body: 'Tercihlerini burada ayarlayabilirsin.'
      },
      behavior: { showOnce: true, autoDismissMs: 4000, blockInteraction: false },
      position: 'left'
    },
    {
      id: 'ctx_night_mode',
      page: '*',
      targetSelector: '[data-hint="night-mode"]',
      trigger: { type: 'onEvent', event: 'NIGHT_MODE_HINT' },
      level: { min: 'Farkındalık', max: 'Mentor' },
      copy: {
        title: 'Gözlerin Dinlensin',
        body: 'Gece modu aktif. Rahatsız edici ışık yok.'
      },
      behavior: { showOnce: true, autoDismissMs: 3000, blockInteraction: false },
      position: 'bottom'
    },
    {
      id: 'ctx_error_friendly',
      page: '*',
      targetSelector: '[data-hint="error"]',
      trigger: { type: 'onEvent', event: 'ERROR_OCCURRED' },
      level: { min: 'Farkındalık', max: 'Mentor' },
      copy: {
        title: 'Teknoloji Yorulur...',
        body: 'Sorun değil. Bir nefes al ve tekrar dene.'
      },
      behavior: { showOnce: false, autoDismissMs: 4000, blockInteraction: false },
      position: 'center'
    },
    {
      id: 'ctx_break_suggestion',
      page: '*',
      targetSelector: '[data-hint="break"]',
      trigger: { type: 'onEvent', event: 'LONG_SESSION' },
      level: { min: 'Farkındalık', max: 'Ustalık' },
      copy: {
        title: 'Mola Zamanı',
        body: 'Durmak... hazırlıktır. Biraz dinlen, sonra devam et.'
      },
      behavior: { showOnce: false, autoDismissMs: 5000, blockInteraction: false },
      position: 'center'
    },
    {
      id: 'ctx_neuro_mode',
      page: '/panel/telkinler',
      targetSelector: '[data-hint="neuro-modes"]',
      trigger: { type: 'onElementVisible' },
      level: { min: 'Farkındalık', max: 'Dönüşüm' },
      copy: {
        title: 'Nörobilim Modları',
        body: 'Theta, Alpha, Beta, Delta... Zihninin ihtiyacına göre mod seç.'
      },
      behavior: { showOnce: true, autoDismissMs: 5000, blockInteraction: false },
      position: 'bottom'
    }
  ]
};

// Level visibility mapping
export const LEVEL_ORDER = [
  'Farkındalık',
  'Uyanış',
  'Dönüşüm',
  'Ustalık',
  'Mentor'
];

// Level hint visibility
export const LEVEL_HINT_VISIBILITY = {
  'Farkındalık': { onboarding: true, contextual: true, intensity: 'high' },
  'Uyanış': { onboarding: true, contextual: true, intensity: 'medium' },
  'Dönüşüm': { onboarding: false, contextual: true, intensity: 'low' },
  'Ustalık': { onboarding: false, contextual: false, intensity: 'minimal' },
  'Mentor': { onboarding: false, contextual: false, intensity: 'off' }
};

// ==========================================
// R.H.I.E. GUIDE MESSAGES (Aşama Bazlı)
// Event -> Aşama -> Mesaj eşleştirmesi
// ==========================================

export const RHIE_GUIDE_MESSAGES = {
  'rhie:ritual:completed': {
    Farkındalık: { 
      title: 'Harika ✧', 
      body: 'Bugünün ritüelini tamamladın... Her adım seni dönüştürüyor.',
      duration: 5000 
    },
    Uyanış: { 
      title: 'Tamamlandı ◇', 
      body: 'Ritüel sürekliliğin uzadı... böyle devam.',
      duration: 4000 
    },
    Dönüşüm: { 
      title: 'İşte bu', 
      body: 'Bir adım daha ileri.',
      duration: 3000 
    },
    Ustalık: { 
      title: '✓', 
      body: null,
      duration: 2000 
    },
    Mentor: null
  },
  
  'rhie:streak:extended': {
    Farkındalık: { 
      title: 'Ritüel sürekliliği uzadı ◇', 
      body: (streak) => `${streak} günlük süreklilik! Tutarlılık, dönüşümün anahtarı.`,
      duration: 4000 
    },
    Uyanış: { 
      title: 'Süreklilik +1 ◇', 
      body: 'Momentum seninle!',
      duration: 3000 
    },
    Dönüşüm: { 
      title: '+1', 
      body: null,
      duration: 2000 
    },
    Ustalık: null,
    Mentor: null
  },
  
  'rhie:streak:broken': {
    Farkındalık: { 
      title: 'Bu düşüş değil ◇', 
      body: 'Ritüel sürekliliği kırıldı… fakat niyetin devam ediyor. Hazırsan başlayabilirsin.',
      duration: 5000 
    },
    Uyanış: { 
      title: 'Yeniden Başla', 
      body: 'Aynı yere değil… daha bilinçli geri dön.',
      duration: 4000 
    },
    Dönüşüm: { 
      title: 'Yolculuğunu sürdür', 
      body: 'Bugün yeni bir gün.',
      duration: 3000 
    },
    Ustalık: null,
    Mentor: null
  },
  
  'rhie:streak:at_risk': {
    Farkındalık: { 
      title: 'Sürekliliğini Koru ◈', 
      body: 'Bugün henüz ritüelini tamamlamadın. Şimdi… kendine izin ver.',
      duration: 6000 
    },
    Uyanış: { 
      title: 'Hatırlatma', 
      body: 'Ritüel seni çağırıyor.',
      duration: 4000 
    },
    Dönüşüm: null,
    Ustalık: null,
    Mentor: null
  },
  
  'rhie:streak:milestone': {
    Farkındalık: { 
      title: 'Dönüşüm Adımı ✦', 
      body: (days) => `${days} gün! Devam ettiğinde… farkı göreceksin.`,
      duration: 6000 
    },
    Uyanış: { 
      title: 'Dönüşüm Adımı ✦', 
      body: (days) => `${days} günlük süreklilik!`,
      duration: 5000 
    },
    Dönüşüm: { 
      title: '✦', 
      body: (days) => `${days} gün`,
      duration: 3000 
    },
    Ustalık: null,
    Mentor: null
  },
  
  'rhie:xp:earned': {
    Farkındalık: { 
      title: 'Zihin Puanı Kazandın ✧', 
      body: (xp) => `+${xp} ZP! Her puan bir adım.`,
      duration: 3000 
    },
    Uyanış: { 
      title: '+ZP', 
      body: (xp) => `${xp} ZP kazandın`,
      duration: 2500 
    },
    Dönüşüm: null,
    Ustalık: null,
    Mentor: null
  },
  
  'rhie:level:up': {
    Farkındalık: { 
      title: 'YENİ AŞAMA ✦', 
      body: (level) => `Lonca kapıları… hazır olduğunda açılır. Artık ${level} aşamasındasın!`,
      duration: 6000 
    },
    Uyanış: { 
      title: 'Zihin Aşaman Yükseldi!', 
      body: (level) => `Yeni aşama: ${level}`,
      duration: 4000 
    },
    Dönüşüm: { 
      title: '⬆️', 
      body: (level) => level,
      duration: 3000 
    },
    Ustalık: { 
      title: 'Aşama Yükseldi', 
      body: null,
      duration: 2000 
    },
    Mentor: null
  },
  
  'rhie:badge:earned': {
    Farkındalık: { 
      title: 'Yeni Rozet ◈', 
      body: (badge) => `"${badge}" rozetini kazandın! Usta sembolü… taşıyana sorumluluk yükler.`,
      duration: 5000 
    },
    Uyanış: { 
      title: 'Rozet!', 
      body: (badge) => badge,
      duration: 4000 
    },
    Dönüşüm: { 
      title: '◈', 
      body: null,
      duration: 2000 
    },
    Ustalık: null,
    Mentor: null
  },
  
  'rhie:ai:drop_risk': {
    Farkındalık: { 
      title: 'Seni Özledik ◇', 
      body: 'Belki şimdi değil… fakat geri döndüğünde kapı açık.',
      duration: 6000 
    },
    Uyanış: { 
      title: 'Geri Dön', 
      body: 'Yolculuğun seni bekliyor.',
      duration: 4000 
    },
    Dönüşüm: null,
    Ustalık: null,
    Mentor: null
  },
  
  // P2 - Yeni Event Mesajları
  'rhie:ai:recommendation_shown': {
    Farkındalık: { 
      title: 'Sana Özel Öneri ◈', 
      body: 'Bu telkin geçmiş tercihlerine göre seçildi.',
      duration: 5000 
    },
    Uyanış: { 
      title: 'Öneri', 
      body: 'Sana uygun bir seçim.',
      duration: 3000 
    },
    Dönüşüm: null,
    Ustalık: null,
    Mentor: null
  },
  
  'rhie:drop_risk:medium': {
    Farkındalık: { 
      title: 'Nazik Bir Hatırlatma ∗', 
      body: 'Ritüellerinden biraz uzaklaştın. Ritüel seni çağırıyor.',
      duration: 6000 
    },
    Uyanış: { 
      title: 'Hatırlatma', 
      body: 'Şimdi… bir nefes.',
      duration: 4000 
    },
    Dönüşüm: null,
    Ustalık: null,
    Mentor: null
  },
  
  'rhie:drop_risk:high': {
    Farkındalık: { 
      title: 'Motivasyonunu Kaybetme ◈', 
      body: 'Uzun süredir görüşemedik. Bugün… dönüşüm adımı.',
      duration: 7000 
    },
    Uyanış: { 
      title: 'Geri Dön', 
      body: '5 dakika yeter.',
      duration: 4000 
    },
    Dönüşüm: null,
    Ustalık: null,
    Mentor: null
  },
  
  'rhie:drop_risk:critical': {
    Farkındalık: { 
      title: 'Seninle Konuşalım ∗', 
      body: 'Uzun bir ara verdin. Bu bir kayıp değil… dönüşün başlangıcı.',
      duration: 8000 
    },
    Uyanış: { 
      title: 'Özledik', 
      body: 'Küçük bir adım at.',
      duration: 5000 
    },
    Dönüşüm: null,
    Ustalık: null,
    Mentor: null
  },
  
  'rhie:drop_risk:recovered': {
    Farkındalık: { 
      title: 'Geri Döndün ✧', 
      body: 'Harika. Aynı yere değil… daha bilinçli geri döndün.',
      duration: 6000 
    },
    Uyanış: { 
      title: 'Hoş Geldin!', 
      body: 'Yolculuğunu sürdür!',
      duration: 4000 
    },
    Dönüşüm: { 
      title: '✨', 
      body: null,
      duration: 2000 
    },
    Ustalık: null,
    Mentor: null
  },
  
  'rhie:motivation:low': {
    Farkındalık: { 
      title: 'Motivasyon Düşük mü? 🌊', 
      body: 'Bazen böyle günler olur. Bu hata değil… mola.',
      duration: 6000 
    },
    Uyanış: { 
      title: 'Hazırım', 
      body: 'Dinlen, sonra devam et.',
      duration: 4000 
    },
    Dönüşüm: null,
    Ustalık: null,
    Mentor: null
  },
  
  'rhie:guide:intensity_changed': {
    Farkındalık: { 
      title: 'Rehber Ayarı Güncellendi 🎚️', 
      body: 'Zihin aşamana uygun rehberlik alıyorsun.',
      duration: 4000 
    },
    Uyanış: null,
    Dönüşüm: null,
    Ustalık: null,
    Mentor: null
  }
};

export default HINT_CONFIG;
